import styled from 'styled-components';

const StyledP = styled.div`
  .body-copy-component {
    color: ${(props) =>
      props.paragraphColor ? props.paragraphColor : '#6d6e71'};
    font-family: 'source-sans-pro', sans-serif;
    font-size: ${({ props }) =>
      (props.paragraphType === null && '16px') ||
      (props.paragraphType === 'larger-intro' && '22px') ||
      (props.paragraphType === 'small' && '14px') ||
      (props.paragraphType === 'small-sm-line-height' && '14px')};
    line-height: ${({ props }) =>
      (props.paragraphType === null && '27px') ||
      (props.paragraphType === 'larger-intro' && '33px') ||
      (props.paragraphType === 'small' && '22px') ||
      (props.paragraphType === 'small-sm-line-height' && '18px')};
  }
`;

export default StyledP;
